import { Button } from "components";
import AssignmentFields from "pages/AppPages/TherapistPages/SinglePatient/components/PatientWorkbook/components/AssignmentDetails/AssignmentFields";
import React, { useContext } from "react";
import ReactTooltip from "react-tooltip";
import { useTranslation } from "react-i18next";
import { useAddAssignment } from "utils/hooks";
import CurrentAssignmentContext from "pages/AppPages/TherapistPages/Resources/components/Assignments/CurrentAssignmentContext";
import useAssignmentLibraryUtils from "pages/AppPages/TherapistPages/Resources/components/Assignments/useAssignmentLibraryUtils";
import { truncateText } from "utils/helpers";
import "./AssignmentPreview.styles.scss";

interface AssignmentPreviewProps {
  handleCloseAssignmentModal: () => void;
}

const AssignmentPreview = ({
  handleCloseAssignmentModal,
}: AssignmentPreviewProps) => {
  const {
    currentNotification,
    patientHasAssignment,
    currentPatient,
    currentGroup,
  } = useAssignmentLibraryUtils();

  const { currentAssignment, setCurrentAssignment } = useContext(
    CurrentAssignmentContext
  );
  const { addAssignment, addGroupAssignment } = useAddAssignment();
  const { t } = useTranslation("common");

  const handleAssignmentTypeClicked = (assignment: any) => {
    currentGroup
      ? addGroupAssignment({
          args: {
            actionPlanId: null,
            groupId: currentGroup?.uuid ?? null,
            type: assignment.type,
            notification: currentNotification,
            templateUUID: assignment.uuid,
          } as any,
          groupSlug: currentGroup?.slug,
          origin: "workbook",
        })
      : addAssignment({
          args: {
            actionPlanId: null,
            patientId: currentPatient?.uuid ?? null,
            type: assignment.type,
            notification: currentNotification,
            templateUUID: assignment.uuid,
          } as any,
          patientSlug: currentPatient?.slug,
          origin: "workbook",
        });
    setCurrentAssignment(null);
    handleCloseAssignmentModal();
  };

  return (
    <div className="assignment-preview-panel">
      <div className="side-panel__header flex assignment-preview-panel__header">
        <div className="assignment-preview-panel-tabs">
          <h4 className="side-panel__header-title assignment-preview-panel__title">
            {currentAssignment?.label || currentAssignment?.title}
          </h4>
          <div className="preview-tag">{t("common_labels.preview")}</div>
        </div>
      </div>
      <div
        data-tip
        data-for="preview-tip"
        className="assignment-preview-fields-wrapper"
      >
        <AssignmentFields
          assignment={currentAssignment?.content}
          isDisplayedInModal={true}
        />
      </div>
      {currentAssignment && (
        <div
          data-tip
          data-for={`${currentAssignment?.type}-tip`}
          className="assignment-preview-panel__actions"
        >
          {(currentPatient || currentGroup) && (
            <Button
              name="add_assignment_button"
              value={t("calls_to_action.assign_to", {
                name: currentPatient
                  ? truncateText(
                      currentPatient?.firstName ?? currentPatient?.email
                    )
                  : currentGroup?.name,
              })}
              extraClass="primary pill submit_btn"
              onClick={() => handleAssignmentTypeClicked(currentAssignment)}
            />
          )}
          {patientHasAssignment(currentAssignment?.type) && (
            <ReactTooltip id={`${currentAssignment?.type}-tip`} place="top">
              {currentGroup
                ? currentGroup.name
                : currentPatient?.firstName ?? currentPatient.email}{" "}
              already has a{" "}
              {currentAssignment?.label || currentAssignment?.title} assigned to
              them.
            </ReactTooltip>
          )}

          <ReactTooltip id="preview-tip" place="left">
            This is a preview and cannot be filled in or submitted
          </ReactTooltip>
        </div>
      )}
    </div>
  );
};

export default AssignmentPreview;
